import instantMessageSignInOperation from 'owa-service/lib/operation/instantMessageSignInOperation';
import ucmaServiceOptions from './ucmaServiceOptions';

export default function signIn(signedInManually: boolean): Promise<number> {
    const options = {
        signedInManually,
    };

    return instantMessageSignInOperation(options, ucmaServiceOptions);
}
